const textsNotifications = {
  InviteFavororite: { title: 'Você foi favoritado!', msg: 'Abra o app agora e confira qual empresa que te favoritou!' },
}

export const VERSION = '2.0.0'

export default textsNotifications
